module.exports = "images/ipm.svg";